import * as React from 'react';
import { EditorState, convertFromRaw } from 'draft-js';
import { UilPen, UilTimes } from '@iconscout/react-unicons';

/**
 * @TODO: document + typing
 */
const dynamicText = ({
    className,
    language,
    editorState,
    editable = false,
    toggleShowAnswerReference,
    deleteEntity,
    disabled
}) => {
    const component = (className, languageeditorState) => {
        return function wrappedComponent({
            entityKey,
            children,
            contentState,
            ...props
        }) {
            const [showHoverContainer, setShowHoverContainer] =
                React.useState(false);
            const type = contentState.getEntity(entityKey).getType();
            const data = contentState.getEntity(entityKey).getData();
            const disableEditByType = ['ROOT_REFERENCE'].includes(type);
            return (
                <span
                    aria-readonly={true}
                    contentEditable={editable}
                    data-offset-key={props.offsetKey}
                    className={
                        className ? className : 'answer--reference--span'
                    }
                    onMouseOver={(e) => setShowHoverContainer(true)}
                    onMouseLeave={(e) => setShowHoverContainer(false)}
                >
                    {children}
                    {showHoverContainer && !disabled && (
                        <div className="answer--reference--span--hover--container">
                            {!disableEditByType ? (
                                <span
                                    className="answer--reference--span--hover--item"
                                    onClick={() =>
                                        toggleShowAnswerReference(
                                            true,
                                            data?.option?.value,
                                            {
                                                entityKey,
                                                offsetKey: props.offsetKey
                                            }
                                        )
                                    }
                                >
                                    <UilPen size={15} />
                                </span>
                            ) : null}
                            <span
                                className="answer--reference--span--hover--item"
                                onClick={() =>
                                    deleteEntity(entityKey, props.offsetKey)
                                }
                            >
                                <UilTimes size={15} />
                            </span>
                        </div>
                    )}
                </span>
            );
        };
    };
    return {
        strategy: findDynamicTextEntities,
        component: component(className, language)
    };
};

/**
 * @TODO: document + typing
 */
function findDynamicTextEntities(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges((character) => {
        const entityKey = character.getEntity();
        return (
            entityKey !== null &&
            [
                'DYNAMIC_TEXT_REFERENCE',
                'DYNAMIC_IMAGE_REFERENCE',
                'ROOT_REFERENCE',
                'BATCH_EDIT'
            ].includes(contentState.getEntity(entityKey).getType())
        );
    }, callback);
}

/**
 * @TODO: document + typing
 */
export const getDecorators = (config) => dynamicText(config);
